import * as React from 'react';

import loadables from '@containers/App/loadables';

import { useWishlistId } from './hooks/useWishlistId';

// TODO: remove after 90 days after PROD deployment
export const TemporaryWishlistRouting = () => {
  const { sharedListId } = useWishlistId();
  return sharedListId ? <loadables.WishList /> : <loadables.WishlistLists />;
};
